import { render, staticRenderFns } from "./home2.vue?vue&type=template&id=65a74ed2&scoped=true&"
import script from "./home2.vue?vue&type=script&lang=js&"
export * from "./home2.vue?vue&type=script&lang=js&"
import style0 from "./home2.vue?vue&type=style&index=0&id=65a74ed2&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a74ed2",
  null
  
)

export default component.exports